import { PropsWithChildren, FC } from 'react';

interface ThemeProviderProps {
    /**
     * Функция, которая возвращает токены и класс темы.
     * Должна создаваться с помощью [@hh.ru/magritte-design-tokens-utils](https://forgejo.pyn.ru/hhru/magritte/src/branch/master/packages/design-tokens-utils#readme)
     * @param tokensVersion Версия пакета magritte-design-tokens для которой создается тема
     * @returns Объект с токенами и классом темы
     **/
    themeProducer: (tokensVersion: string) => { tokensString: string; themeClassName: string };
}

export const ThemeProvider: FC<PropsWithChildren<ThemeProviderProps>> = ({ children, themeProducer }) => {
    // __TOKENS_VERSION__ is replaced by the build process
    const { tokensString, themeClassName } = themeProducer('__TOKENS_VERSION__');

    return (
        <>
            <style>{tokensString}</style>
            <div className={themeClassName}>{children}</div>
        </>
    );
};
